import Button from '@mui/material/Button'
import type { MouseEventHandler, ReactNode } from 'react'
import { Link } from 'react-router-dom'

type AppLinkButtonProps = {
  ariaLabel?: string
  children: ReactNode
  className?: string
  endIcon?: ReactNode
  onClick?: MouseEventHandler<HTMLAnchorElement>
  size?: 'small' | 'medium' | 'large'
  startIcon?: ReactNode
  to: string
  variant?: 'contained' | 'outlined' | 'text'
}

export function AppLinkButton({
  ariaLabel,
  children,
  className,
  endIcon,
  onClick,
  size,
  startIcon,
  to,
  variant = 'contained',
}: AppLinkButtonProps) {
  return (
    <Button
      aria-label={ariaLabel}
      className={className}
      color="success"
      component={Link}
      endIcon={endIcon}
      onClick={onClick}
      size={size}
      startIcon={startIcon}
      to={to}
      variant={variant}
    >
      {children}
    </Button>
  )
}
